module.exports = __webpack_public_path__ + "static/media/ProbabilityTree2.ce5d6c05.jpg";